(function () {
  var BLOG_HIDDEN = 'menu__item--blog-hidden';
  var PILL_INSET = 12;
  var resizeTimer;

  function isDesktopHeaderVisible() {
    var desktop = document.querySelector('[data-header-desktop]');
    return desktop && window.getComputedStyle(desktop).display !== 'none';
  }

  function getPillRight(headerRect) {
    if (window.innerWidth >= 1362) {
      return headerRect.left + headerRect.width - 96;
    }

    return headerRect.left + headerRect.width - 10;
  }

  function getMaxContentRight() {
    var header = document.querySelector('.theme__header');
    if (!header) return window.innerWidth;

    var pillRight = getPillRight(header.getBoundingClientRect());
    var langSwitcher = document.getElementById('lang-switcher-desktop');

    if (langSwitcher && window.getComputedStyle(langSwitcher).display !== 'none') {
      return Math.min(pillRight, langSwitcher.getBoundingClientRect().left) - PILL_INSET;
    }

    return pillRight - PILL_INSET;
  }

  function getRightmostEdge() {
    var cart = document.querySelector('.header__desktop__buttons .navlink--cart');
    if (cart) return cart.getBoundingClientRect().right;

    var buttons = document.querySelector('.header__desktop__buttons');
    return buttons ? buttons.getBoundingClientRect().right : 0;
  }

  function iconsOverflow() {
    return getRightmostEdge() > getMaxContentRight();
  }

  function updateBlogVisibility() {
    if (!isDesktopHeaderVisible()) return;

    var blogItems = document.querySelectorAll('.header__desktop .menu__item--blog');
    if (!blogItems.length) return;

    blogItems.forEach(function (el) {
      el.classList.remove(BLOG_HIDDEN);
    });

    if (iconsOverflow()) {
      blogItems.forEach(function (el) {
        el.classList.add(BLOG_HIDDEN);
      });
    }
  }

  function scheduleUpdate() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(updateBlogVisibility, 50);
  }

  function init() {
    updateBlogVisibility();
    window.addEventListener('resize', scheduleUpdate);
    window.addEventListener('scroll', scheduleUpdate);
    document.addEventListener('theme:resize', scheduleUpdate);

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(scheduleUpdate);
    }

    setTimeout(updateBlogVisibility, 300);
    setTimeout(updateBlogVisibility, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
